import { OPPORTUNITY_STAGES } from '../constants';

function getRelatedAgreementBudget(opportunities, agreementId) {
  return opportunities.reduce((total, opportunity) => {
    const relatedAgreementBudget = opportunity.agreementOpportunities.find(
      ao => ao.agreement === agreementId,
    ).budget;
    return total + relatedAgreementBudget;
  }, 0);
}

export default function getPlannedAndAgreedBudgets(opportunities, agreementId) {
  const plannedOpportunities = [];
  const agreedOpportunities = [];

  opportunities.forEach(opportunity => {
    const { stage } = opportunity;
    if (stage === OPPORTUNITY_STAGES.AGREED) {
      agreedOpportunities.push(opportunity);
    } else if (stage !== OPPORTUNITY_STAGES.CLOSED_LOST) {
      plannedOpportunities.push(opportunity);
    }
  });

  const plannedBudget = getRelatedAgreementBudget(
    plannedOpportunities,
    agreementId,
  );
  const agreedBudget = getRelatedAgreementBudget(
    agreedOpportunities,
    agreementId,
  );
  return { plannedBudget, agreedBudget };
}
